module.exports = __webpack_public_path__ + "static/media/foto.0db15439.jpg";